export default "__VITE_ASSET__BpszwCv$__"